<div
    class="ttw-fixed tw-relative tw-px-4 md:tw-justify-center tw-w-full tw-py-3 tw-bg-[#94A4FF] tw-z-[99999] tw-flex ttw-shadow-[0px_5px_15px_rgba(0,0,0,0.2)] tw-items-center tw-gap-2 md:tw-gap-5 tw-top-0 tw-pr-[15%] md:tw-pr-[5%] md:tw-text-center"
>
    <mat-icon class="tw-text-white tw-min-w-fit"> settings </mat-icon>
    <div
        class="tw-font-medium tw-text-white tw-text-sm"
        [innerHTML]="globalToasterSerive.getToaster().message"
    ></div>
    <button
        class="tw-absolute tw-right-5 tw-text-white tw-h-[24px] tw-w-[24px]"
        (click)="closeToaster()"
    >
        <mat-icon class="tw-text-white"> clear </mat-icon>
    </button>
</div>
